<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-form
            ref="form"
            v-model="validForm"
            @submit.prevent="changePassword"
          >
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Alterar senha</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                label="Senha atual"
                name="oldPassword"
                required
                v-model="user.oldPassword"
                prepend-icon="mdi-lock"
                :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[$rules.required]"
                :type="showOldPassword ? 'text' : 'password'"
                @click:append="showOldPassword = !showOldPassword"
              ></v-text-field>

              <v-text-field
                id="password"
                label="Nova senha"
                name="password"
                required
                v-model="user.password"
                prepend-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[$rules.required]"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
              <v-text-field
                id="passwordConfirmation"
                label="Confirmação da senha"
                name="passwordConfirmation"
                required
                v-model="user.passwordConfirmation"
                prepend-icon="mdi-lock"
                :append-icon="
                  showConfirmationPassword ? 'mdi-eye' : 'mdi-eye-off'
                "
                :rules="[
                  $rules.required,
                  $rules.checkSamePassword(
                    user.passwordConfirmation,
                    user.password
                  ),
                ]"
                :type="showConfirmationPassword ? 'text' : 'password'"
                @click:append="
                  showConfirmationPassword = !showConfirmationPassword
                "
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                color="primary"
                :loading="changePasswordButton.loading"
                >Solicitar</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import userApi from "@/common/api/user.api";
import toaster from "@/common/util/toaster";

export default {
  name: "ChangePassword",

  data() {
    return {
      user: {},
      validForm: true,
      showOldPassword: false,
      showPassword: false,
      showConfirmationPassword: false,
      changePasswordButton: {
        loading: false,
      },
    };
  },
  methods: {
    changePassword() {
      this.$refs.form.validate();

      if (this.validForm) {
        this.changePasswordButton.loading = true;

        userApi
          .changePassword(this.user.oldPassword, this.user.password)
          .then(() => {
            this.changePasswordButton.loading = false;

            this.$refs.form.reset();
            toaster.show("Senha alterada com sucesso!");
          })
          .catch(() => (this.changePasswordButton.loading = false));
      }
    },
  },
};
</script>